/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

let id = 0;
autoBeforeEachTest(() => {
	id = 0;
});
export const generateId = (): string => {
	id += 1;
	return String(id);
};

type OperationTimedOut = { timedOut: true; result: null; elapsedMs: number };
type OperationCompleted<T> = { timedOut: false; result: T; elapsedMs: number };
export function withTimeout<T>(
	operation: () => Promise<T>,
	ms: number,
): Promise<OperationTimedOut | OperationCompleted<T>> {
	const startTime = Date.now();
	const timeoutPromise = new Promise<OperationTimedOut>((resolve) => {
		setTimeout(() => {
			resolve({ timedOut: true, result: null, elapsedMs: Date.now() - startTime });
		}, ms);
	});
	const operationPromise: Promise<OperationCompleted<T>> = operation().then((result) => ({
		timedOut: false,
		result,
		elapsedMs: Date.now() - startTime,
	}));
	return Promise.race([operationPromise, timeoutPromise]);
}
